import * as t from 'io-ts';
import { NumberFromString } from 'io-ts-types/lib/NumberFromString';
import { UUID } from '@thingos/io-ts-shared';
import { TagId, TemplateBase } from '../models';
export const TemplateCreationResponse = t.type({
    templateId: t.string,
    key: t.string,
});
export const Provision = t.type({
    provisionId: t.string,
});
export const ProvisionCreationRequest = t.intersection([
    t.type({
        templateId: t.string,
        count: t.number,
    }),
    t.partial({ name: t.string }),
]);
export const ProvisionCreationResponse = t.type({
    provisions: t.array(Provision),
});
export const ProvisionIdParamter = t.type({
    id: UUID,
});
export const ProvisionInfoResponse = t.type({
    name: t.string,
    uploaded: t.boolean,
});
export const TemplateIdParameter = t.type({
    id: UUID,
});
export const TemplateSetMaxProvisionsRequest = t.type({
    key: UUID,
    maxProvisions: t.number,
});
export const TemplateSetMaxProvisionsResponse = t.type({
    maxProvisions: t.number,
});
export const GetProvisionCodesForTemplateQuery = t.intersection([
    t.type({
        templateId: UUID,
        key: UUID,
        offset: NumberFromString,
        count: NumberFromString,
    }),
    t.partial({ name: t.string }),
]);
export const TemplateDraftCreationRequest = t.partial(TemplateBase.props);
export const TemplateCreationRequest = t.exact(t.intersection([
    TemplateDraftCreationRequest,
    t.type({
        companyId: t.string,
        isDraft: t.boolean,
    }),
]));
export const TemplateConnectFileUpload = t.type({
    templateId: t.string,
    file: t.unknown,
    name: t.string,
});
export const TemplateConnectFileUploadResponse = t.type({
    connectFileId: t.string,
    connectFileName: t.string,
    connectFileSize: t.number,
});
export const TemplateImageUpload = t.type({
    templateId: t.string,
    file: t.unknown,
});
export const TemplateImageUploadResponse = t.type({
    imageUrl: t.string,
});
export const PostTemplateDataRequestBase = t.intersection([
    TemplateDraftCreationRequest,
    t.type({
        isDraft: t.boolean,
    }),
]);
export const PostNewTemplateDataRequest = t.intersection([
    PostTemplateDataRequestBase,
    t.type({
        companyId: t.string,
    }),
]);
export const PostExistingTemplateDataRequest = t.intersection([
    PostTemplateDataRequestBase,
    t.type({
        templateId: t.string,
    }),
]);
export const PostTemplateDataRequest = t.union([
    PostNewTemplateDataRequest,
    PostExistingTemplateDataRequest,
]);
export function isPostExistingTemplateDataRequest(postTemplateDataRequest) {
    if (postTemplateDataRequest.templateId != null)
        return true;
    return false;
}
export const DeleteTemplateRequest = t.type({
    templateId: t.string,
});
export const GetTemplateConnectFileRequest = t.type({
    templateId: t.string,
});
export const GetTemplateConnectFileResponse = t.type({
    connectFile: t.string,
});
export const AddTagRequest = t.intersection([
    t.type({
        templateId: UUID,
        name: t.string,
    }),
    t.partial({
        id: TagId,
    }),
]);
export const DeleteTagRequest = t.type({
    templateId: UUID,
    id: TagId,
});
//# sourceMappingURL=templates.js.map